// FloatingActionButtons.jsx
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getIsIphoneXSeriesPWA } from '../resource/getUserAgent.js';
import { getShouldShowBottomNavigation } from '../resource/getShouldShowFooter.js';
import media from '../style/media.js';

const isIphoneXSeriesPWA = getIsIphoneXSeriesPWA();

export const FloatingActionButtons = ({
  children,
  isJoin = false,
  isRemoteConfigMerged = false,
  isDisplayingAgeVerify = false,
  isLandingPageShown = false,
}) => {
  const { pathname } = useLocation();
  const isUser = pathname.startsWith('/user/') || pathname.startsWith('/u/');
  const shouldCurrentPathnameShowFooter = getShouldShowBottomNavigation({
    pathname,
  });
  const bottom = useMemo(() => {
    if (isJoin) return 132;
    return (
      0 + // Footer
      17 + // btn margin
      (isIphoneXSeriesPWA ? 34 : 0) +
      (isRemoteConfigMerged && isDisplayingAgeVerify ? 88 : 0)
    );
  }, [isDisplayingAgeVerify, isRemoteConfigMerged, isJoin]);
  const mobileBottom = useMemo(() => {
    if (isJoin) return 132;
    return (
      (shouldCurrentPathnameShowFooter ? 48 : 0) + // Footer
      17 + // btn margin
      (isIphoneXSeriesPWA ? 34 : 0) +
      (isRemoteConfigMerged &&
      isDisplayingAgeVerify &&
      shouldCurrentPathnameShowFooter
        ? 88
        : 0) +
      // (2024.09) (special case: reserve room for pagination on mobile devices)
      // Currently there's only 1 floating button on user profile page,
      // so we don't update BackpackEntranceButton and UserEventEntranceButton for now.
      (isUser ? 110 : 0)
    );
  }, [
    isDisplayingAgeVerify,
    isJoin,
    isRemoteConfigMerged,
    isUser,
    shouldCurrentPathnameShowFooter,
  ]);

  return (
    <StyledFloatingActionButtons
      $isLandingPageShown={isLandingPageShown}
      $bottom={bottom}
      $mobileBottom={mobileBottom}
    >
      {children}
    </StyledFloatingActionButtons>
  );
};

FloatingActionButtons.propTypes = {
  children: PropTypes.node.isRequired,
  isJoin: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
  isDisplayingAgeVerify: PropTypes.bool,
  isLandingPageShown: PropTypes.bool,
};

const StyledFloatingActionButtons = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  right: 16px;
  width: 64px;
  z-index: ${({ $isLandingPageShown }) => ($isLandingPageShown ? 110 : 10)};
  bottom: ${({ $bottom }) => $bottom}px;
  ${media.mobile`
    bottom: ${({ $mobileBottom }) => $mobileBottom}px;
  `}
`;

export default FloatingActionButtons;
